module.exports = __webpack_public_path__ + "static/media/3.382f19a5.jpg";